import {
  requestReducers, errorReducers, pendingReducers, offlineRequestReducers,
} from './state';
import { apiRequest } from './state/request/actions';
import { offlineRequest } from './state/offlineRequest/actions';
import offlineRequestMiddleware from './offlineRequestMiddleware';
import requestApi from './requestApi';
import apiMethods from './methods';

const state = {
  errors: errorReducers,
  pending: pendingReducers,
  request: requestReducers,
  offlineRequest: offlineRequestReducers,
};

export default requestApi;

export {
  state,
  apiMethods,
  apiRequest,
  offlineRequestMiddleware,
  offlineRequest,
};
